import { useState, useContext, lazy, Suspense } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import Info from "@mui/icons-material/Info";
import AccessTime from "@mui/icons-material/AccessTime";
import Notifications from "@mui/icons-material/Notifications";
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import LocalOffer from "@mui/icons-material/LocalOffer";
import { AppContext } from "../App";
import { Link } from "react-router-dom";
import CartSkeletonLoading from "../pricing/CartSkeletonloading";
const Cart = lazy(() => import("../pricing/Cart"));

const PreorderProduct = ({ examId, examName, examCode, price }) => {
  const [isAgreed, setIsAgreed] = useState(false);
  const { setCardItemNumber, toggle, showCart } = useContext(AppContext);

  const discountPercentage = 20;
  const priceAfterDiscount = price; // the price after discount
  const originalPrice = (
    priceAfterDiscount /
    (1 - discountPercentage / 100)
  ).toFixed(0);
  const discountedPrice = priceAfterDiscount;
  const cardData = {
    ExamPrice: parseInt(discountedPrice, 10),
    Id: 3,
    PriceDesc: "Bundle Pack",
    OrderLevel: 3,
    ExamDiscount: 0,
  };
  const handleAgreementChange = (event) => {
    setIsAgreed(event.target.checked);
  };
  const handleAddToCart = (bundelType, dur, type) => {
    const shoppingItems = localStorage.getItem("shoppingItems");
    let prvItem = shoppingItems ? JSON.parse(shoppingItems) : [];
    const shoppingItemsbundle = localStorage.getItem("bundleshoppingItems");
    let prvItembundled = shoppingItemsbundle
      ? JSON.parse(shoppingItemsbundle)
      : [];
    if (prvItem.length) {
      const remaningItem = prvItem.filter((item) => item.examCode !== examCode);
      prvItem = remaningItem || [];
    }
    prvItem.push({
      pack: bundelType,
      duration: dur,
      examCode: examCode,
      exameId: examId,
      type: type,
      price: discountedPrice,
      isPreOrder: true,
    });
    prvItem.map((item, i) => {
      return (item.id = i + 1);
    });
    localStorage.setItem("shoppingItems", JSON.stringify(prvItem));
    //seting for bundle
    if (prvItembundled.length) {
      const remaningItem = prvItembundled.filter(
        (item) => item.examCode !== examCode
      );
      prvItembundled = remaningItem || [];
    }
    prvItembundled.push({
      pack: bundelType,
      duration: dur,
      examCode: examCode,
      exameId: examId,
      type: type,
      vendor: examCode,
      price: price,
      isPreOrder: true,
    });
    prvItembundled.map((item, i) => {
      return (item.id = i + 1);
    });
    localStorage.setItem("bundleshoppingItems", JSON.stringify(prvItembundled));
    setCardItemNumber(prvItem.length);
    toggle();
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: 4,
        borderRadius: 2,
        border: "2px solid #27B1BB",
        backgroundColor: "#F0FFFF",
        maxWidth: 600,
        margin: "auto",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Diagonal Ribbon */}
      <Box
        sx={{
          position: "absolute",
          top: 20,
          right: -50,
          transform: "rotate(45deg)",
          backgroundColor: "#FF9800",
          padding: "5px 0",
          width: 200,
          textAlign: "center",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          zIndex: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: "white",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          Preorder
        </Typography>
        <Tooltip title="This is a preorder product. You'll receive it within 15-20 days after placing your order.">
          <Info
            sx={{
              color: "white",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </Box>

      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#27B1BB",
          fontWeight: "bold",
          marginTop: 2,
          fontSize: "clamp(1.5rem, 5vw, 2.5rem)", // Adjust the min, preferred, and max values as needed
        }}
      >
        {examCode}
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        sx={{ color: "#27B1BB", fontWeight: "600", marginTop: 2 }}
      >
        {examName}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", marginY: 2 }}>
        <AccessTime sx={{ color: "#27B1BB", marginRight: 1 }} />
        <Typography variant="body1">
          Available within <strong>15-20 days</strong>
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", marginY: 2 }}>
        <Notifications sx={{ color: "#27B1BB", marginRight: 1 }} />
        <Typography variant="body1">
          You'll be <strong>notified</strong> when the product becomes available
        </Typography>
      </Box>

      {/* Improved Pricing Section */}
      <Box
        sx={{
          marginY: 3,
          padding: 2,
          backgroundColor: "#E1F5FE",
          borderRadius: 2,
          border: "2px dashed #27B1BB",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#27B1BB",
            marginBottom: 1,
            fontSize: "clamp(1rem, 2.5vw, 1.5rem)", // Adjust the min, preferred, and max values as needed
          }}
        >
          Special Preorder Pricing
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h4"
              component="span"
              sx={{ fontWeight: "bold", color: "#27B1BB" }}
            >
              ${discountedPrice}
            </Typography>
            <Typography
              variant="h6"
              component="span"
              sx={{
                textDecoration: "line-through",
                color: "#888",
                marginLeft: 1,
                mr: 1,
              }}
            >
              ${originalPrice}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "#FF9800",
              padding: "4px 8px",
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocalOffer sx={{ color: "white", marginRight: 1 }} />
            <Typography
              variant="body2"
              sx={{ color: "white", fontWeight: "bold" }}
            >
              Save {discountPercentage}%
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography variant="body2" sx={{ marginY: 2, fontStyle: "italic" }}>
        By placing a preorder, you agree to pay now and receive the product when
        it becomes available.
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={isAgreed}
            onChange={handleAgreementChange}
            sx={{
              color: "#27B1BB",
              "&.Mui-checked": {
                color: "#27B1BB",
              },
            }}
          />
        }
        label={
          <span>
            I agree to the{" "}
            <Link
              to="/preorder-terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "#27B1BB" }}
            >
              preorder terms and conditions
            </Link>
          </span>
        }
        sx={{ marginY: 2 }}
      />

      <Button
        variant="contained"
        startIcon={<ShoppingCart />}
        disabled={!isAgreed}
        onClick={() => handleAddToCart(cardData, "3", "BUNDLE PACK")}
        sx={{
          backgroundColor: "#27B1BB",
          "&:hover": {
            backgroundColor: "#1C7A81",
          },
          "&.Mui-disabled": {
            backgroundColor: "#A0A0A0",
            color: "#FFFFFF",
          },
        }}
      >
        {/* Preorder Now */}
        Add to Cart
      </Button>
      <Stack width="100%" justifyContent="flex-end">
        {showCart && (
          <Suspense fallback={<CartSkeletonLoading />}>
            <Cart open={showCart} onClose={toggle} />
          </Suspense>
        )}
      </Stack>
    </Paper>
  );
};

export default PreorderProduct;
